import {
  legacy_createStore as createStore,
  compose,
  applyMiddleware,
} from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { getDefaultMiddleware } from '../middleware/getDefaultMiddleware';
import { enableDevTools } from '../middleware/enableDevTools';
import { createRootReducer } from '../helpers/createRootReducer';

export const configureStore = (options) => {
  const opts = options || {};
  const {
    reducer,
    middleware = getDefaultMiddleware(),
    preloadedState,
    enhancers = [],
  } = opts;

  let rootReducer;

  if (typeof reducer === 'function') {
    rootReducer = reducer;
  } else if (typeof reducer === 'object') {
    rootReducer = createRootReducer(reducer);
  } else {
    throw new Error(
      [
        'Reducer argument must be a function or an object of functions that ',
        'can be passed to combineReducers',
      ].join(',')
    );
  }

  const middlewareEnhancer = applyMiddleware(...middleware);

  let finalCompose = compose;
  if (enableDevTools()) {
    finalCompose = composeWithDevTools({ trace: true });
  }

  const storeEnhancers = [middlewareEnhancer, ...enhancers];
  const composedEnhancer = finalCompose(...storeEnhancers);

  const store = createStore(rootReducer, preloadedState, composedEnhancer);

  store.replaceReducers = (reducers) => {
    store.replaceReducer(createRootReducer(reducers));
  };

  return store;
};
